import type { TooltipStrings } from '@/constants/localization'

export const depositTooltips: TooltipStrings = {
  swap: () => ({
    title: 'title_deposit', //stringGetter({ key: TOOLTIP_STRING_KEYS.SWAP_TITLE }),
    body: 'body_deposit', //stringGetter({ key: TOOLTIP_STRING_KEYS.SWAP_BODY }),
  }),
} as const
